import PropTypes from "prop-types";

const IntegrationCard = ({ icon, title, desc }) => {
    return (
        <div className="relative w-full h-full flex items-center justify-center">
            {/* Viền xanh nghiêng luôn hiển thị */}
            <div className="absolute inset-0 rounded-2xl bg-[#5AE65E] -rotate-2 z-0 transition-transform duration-300" />
            {/* Nội dung card */}
            <div className="relative z-10 bg-[#181f16] rounded-2xl \ p-8 flex flex-col items-center text-center w-full h-full">
                <div className="text-green-400 text-5xl mb-4">
                    <span role="img" aria-label="icon">{icon}</span>
                </div>
                <h3 className="text-xl font-semibold text-white mb-2">{title}</h3>
                <p className="text-gray-300 text-sm">{desc}</p>
            </div>
        </div>
    );
};

IntegrationCard.propTypes = {
    icon: PropTypes.node.isRequired,
    title: PropTypes.string.isRequired,
    desc: PropTypes.string.isRequired,
    boxShadow: PropTypes.string
};

export default IntegrationCard; 